<template>
  <div class="container py-8">
    <div class="flex flex-col max-w-sm mx-auto mb-12">
      <div class="flex w-full pt-3 space-x-2 border-gray-400"></div>

      <form class="flex flex-col items-center" @submit.prevent="handleReturnsAuth">
        <h3 class="fluid-xl leading-tight font-medium mt-10 mb-6 text-center">
          <slot>{{ $t('returns.auth.title') }}</slot>
        </h3>

        <p class="mb-6">
          {{ $t('returns.auth.description') }}
        </p>

        <FormTextInput v-model="form.email" :label="$t('returns.auth.email')" :error="form.errors.email" required />

        <FormTextInput v-model="form.order" :label="$t('returns.auth.order')" :error="form.errors.order" required />

        <GenericFormError v-if="form.errors.message || error">
          {{ form.errors.message || error }}
        </GenericFormError>

        <FormButton class="self-center" :is-loading="form.processing">{{ $t('returns.auth.button') }}</FormButton>
      </form>
    </div>
  </div>
</template>

<script>
import * as yup from 'yup';
import FormButton from '@/components/account/FormButton';
import FormTextInput from '@/components/account/FormTextInput';
import GenericFormError from '@/components/account/GenericFormError';
import form from '@/utils/form';

export default {
  components: {
    FormButton,
    FormTextInput,
    GenericFormError,
  },

  data() {
    return {
      error: null,
      form: form(
        {
          email: '',
          order: '',
        },
        yup.object().shape({
          email: yup
            .string()
            .required(this.$t('account.fields.email.required'))
            .email(this.$t('account.fields.email.email')),
          order: yup.string().required(this.$t('returns.fields.order.required')),
        })
      ),
    };
  },

  created() {
    if (this.$route.query.error) {
      this.error = this.$route.query.error;

      this.$router.replace({ query: {} });
    }
  },

  methods: {
    handleReturnsAuth() {
      this.error = null;
      this.form.validate().then(() => {
        const params = new URLSearchParams();
        params.append('email', this.form.email);
        params.append('order', this.form.order);

        // navigate to return order page
        this.$router.push(this.$localeRootPath('returns/order') + '?' + params.toString());
      });
    },
  },
};
</script>
